/**
 * Opens a URL in a new tab only when it resolves to an http(s) or blob destination.
 *
 * Document URLs reaching the UI originate from API responses, so a tampered or
 * malformed response must not be able to hand the browser a `javascript:`,
 * `data:` or attacker-chosen destination.
 *
 * @param {string} url - The candidate destination URL.
 * @returns {boolean} - True when the URL was considered safe and opened.
 */
export const openSafeUrl = (url: string): boolean => {
  if (!url) return false;

  try {
    const resolved = new URL(url, window.location.origin);
    if (!["http:", "https:", "blob:"].includes(resolved.protocol)) {
      return false;
    }

    const opened = window.open(resolved.href, "_blank", "noopener,noreferrer");
    if (opened) opened.opener = null;
    return true;
  } catch {
    return false;
  }
};
